import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type SnackbarSeverity = 'success' | 'error' | 'info' | 'warning';

interface SnackbarState {
  message: string;
  severity?: SnackbarSeverity;
  key?: number;
  displayed?: boolean;
}

const initialState: SnackbarState[] = [];

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action: PayloadAction<SnackbarState>) => {
      state.push({ ...action.payload, key: Date.now(), displayed: false });
    },

    closeSnackbar: (state, action: PayloadAction<number>) => {
      const index = state.findIndex(snackbar => snackbar.key === action.payload);
      if (index !== -1) state[index].displayed = true;
    },

    removeSnackbar: (state, action: PayloadAction<number>) => {
      return state.filter(snackbar => snackbar.key !== action.payload);
    },
  },
});

export const { showSnackbar, closeSnackbar, removeSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
